export const environment = {
    production: true,
    octobus: 'wss://ms.utaxcloud.net/octobus/v1/watcher/ws',
};
